// extracted by mini-css-extract-plugin
export default {"customButton":"CreateButton_customButton__wZ1Kt"};